import { Modal, useModals } from 'almanac-ui/Modal'

import Styles from './InvoicesModal.module.scss'
import { useRootStore } from 'stores/RootStore'
import dayjs from 'dayjs'
import { useCustomerInvoices } from './useCustomerInvoices'
import { StripeInvoice } from 'components/Settings/Workspace/VirtualMarketerUpgradeCta/types'
import { Spinner } from 'common/Spinner/Spinner'
import { Text } from 'blaze-ui/Text/Text'
import { formatPrice } from 'components/Settings/TieredBilling/utils'
import { ButtonLink } from 'blaze-ui/Button/ButtonLink'
import { nameMap } from 'components/Settings/Workspace/AutopilotPlans/components/Plans/components/PlanDetails/PlanDetails'

export const InvoicesModal = () => {
  const { closeModal } = useModals()
  const { data: customerInvoices, isLoading } = useCustomerInvoices()
  const { autopilotPlans } = useRootStore().tierUsageStore

  const purchaseType = (invoice: StripeInvoice) => {
    const item = invoice.lines.data[0]

    if (item.description === 'Blaze Autopilot Content Credits') {
      return 'Credit purchase'
    }

    const plan = autopilotPlans.find((p) => p.id === item.price.product)
    const price = plan?.prices.find((p) => p.id === item.price.id)
    const months = price?.recurring.interval_count

    if (!plan || !price || !months) {
      return 'Unknown'
    }

    return `${nameMap[plan?.key]} / ${months === 1 ? 'Monthly' : `${months} months`}`
  }

  return (
    <Modal.Root>
      <Modal.Header title="Billing History" />
      <Modal.Content>
        {isLoading && (
          <div className={Styles.loading}>
            <Spinner />
          </div>
        )}
        {customerInvoices && (
          <div className={Styles.invoicesTable}>
            <div className={Styles.header}>
              <div className={Styles.date}>
                <Text variant="label">Date</Text>
              </div>
              <div className={Styles.amount}>
                <Text variant="label">Amount</Text>
              </div>
              <div className={Styles.type}>
                <Text variant="label">Type</Text>
              </div>
              <div className={Styles.invoice}>
                <Text variant="label">Invoice</Text>
              </div>
            </div>
            <div className={Styles.body}></div>
            {customerInvoices?.map((invoice: StripeInvoice) => (
              <div key={invoice.id} className={Styles.invoiceRow}>
                <div className={Styles.date}>
                  <Text lineClamp={1} variant="secondary">
                    {dayjs.unix(invoice.created).format('MMM D, YYYY')}
                  </Text>
                </div>
                <div className={Styles.amount}>
                  <Text variant="secondary">${formatPrice(invoice.amount_paid / 100)} USD</Text>
                </div>
                <div className={Styles.type}>
                  <Text variant="secondary" lineClamp={1}>
                    {purchaseType(invoice)}
                  </Text>
                </div>
                <div className={Styles.invoice}>
                  <ButtonLink to={invoice.hosted_invoice_url || ''} target="_blank" variant="ghost">
                    View
                  </ButtonLink>
                </div>
              </div>
            ))}
          </div>
        )}
      </Modal.Content>
      <Modal.Footer>
        <Modal.FooterContent slot="left">
          <Modal.FooterButton variant="tertiary" onPress={closeModal}>
            Back
          </Modal.FooterButton>
        </Modal.FooterContent>
        <Modal.FooterButton>Close</Modal.FooterButton>
      </Modal.Footer>
    </Modal.Root>
  )
}
